/* eslint @typescript-eslint/naming-convention : 0 */
export const Illustrations = {
    AANMELDEN: 'aanmelden',
    AANMELDENMOBIEL: 'aanmelden-mobiel',
    AANMELDENSUCCES: 'aanmelden-succes',
    ADVIESKEUZE: 'advieskeuze',
    AFMRISKSCORE1: 'afm-riskscore-1',
    AFMRISKSCORE2: 'afm-riskscore-2',
    AFMRISKSCORE3: 'afm-riskscore-3',
    AFMRISKSCORE4: 'afm-riskscore-4',
    AFMRISKSCORE5: 'afm-riskscore-5',
    AFMRISKSCORE6: 'afm-riskscore-6',
    ANNUITEITEN: 'annuiteiten',
    ASNMISSIE: 'asn-missie',
    AVATAR: 'avatar',
    AVATARAGENT: 'avatar-agent',
    AVATARAGENTDARK: 'avatar-agent-dark',
    AVATARBOT: 'avatar-bot',
    AVATARBOTDARK: 'avatar-bot-dark',
    BELEGGENDOEL: 'beleggen-doel',
    BELEGGENGROEI: 'beleggen-groei',
    BETA: 'beta',
    BETAALPAS: 'betaalpas',
    BETAALPASJUNIOR: 'betaalpas-junior',
    BETAALPAS2: 'betaalpas2',
    BETALENSUCCES: 'betalen-succes',
    BIODIVERSITY: 'biodiversity',
    CHAT: 'chat',
    CODEPOSTSMSEMAIL: 'code-post-sms-email',
    CODESMSEMAIL: 'code-sms-email',
    DEBITCARD: 'debit-card',
    DEBITCARDYOUTH: 'debit-card-youth',
    DIGIPASBACK: 'digipas-back',
    DIGIPASFRONT: 'digipas-front',
    DOORGAAN: 'doorgaan',
    EMPTY: 'empty',
    EMPTYSTATE: 'empty-state',
    ENERGYLABELA: 'energy-label-a',
    ENERGYLABELAP_APP: 'energy-label-ap_app',
    ENERGYLABELAPP: 'energy-label-app',
    ENERGYLABELAPPP: 'energy-label-appp',
    ENERGYLABELAPPPP: 'energy-label-apppp',
    ENERGYLABELAPPPP10YR: 'energy-label-apppp10yr',
    ENERGYLABELB: 'energy-label-b',
    ENERGYLABELC_D: 'energy-label-c_d',
    ENERGYLABELE_F_G: 'energy-label-e_f_g',
    EPPO: 'eppo',
    ERROR: 'error',
    EVENGEDULD: 'even-geduld',
    EVENGEDULD2: 'even-geduld2',
    FACEID: 'faceID',
    FACEIDVINGERAFDRUK: 'faceID-vingerafdruk',
    FEEDBACK: 'feedback',
    GEMACHTIGDE: 'gemachtigde',
    GEMACHTIGDENOBG: 'gemachtigde-nobg',
    GEPLAND: 'gepland',
    HOUSE: 'house',
    HYPOTHEKENHUISJE: 'hypotheken-huisje',
    HYPOTHEKENHUISJEDARK: 'hypotheken-huisje-dark',
    HYPOTHEKENSTAP1: 'hypotheken-stap1',
    HYPOTHEKENSTAP1DARK: 'hypotheken-stap1-dark',
    HYPOTHEKENSTAP2: 'hypotheken-stap2',
    HYPOTHEKENSTAP2DARK: 'hypotheken-stap2-dark',
    HYPOTHEKENSTAP3: 'hypotheken-stap3',
    HYPOTHEKENSTAP3DARK: 'hypotheken-stap3-dark',
    IDENTIFICEREN: 'identificeren',
    IDENTITEITSBEWIJS: 'identiteitsbewijs',
    KIND: 'kind',
    KINDNOBG: 'kind-nobg',
    KLAAR: 'klaar',
    LINEAIR: 'lineair',
    LOGOASN: 'logo-asn',
    LOGOASNDARK: 'logo-asn-dark',
    LOGOBLG: 'logo-blg',
    LOGOBLGDARK: 'logo-blg-dark',
    LOGOREB: 'logo-reb',
    LOGOREBDARK: 'logo-reb-dark',
    LOGOSNS: 'logo-sns',
    LOGOSNSDARK: 'logo-sns-dark',
    MICROKREDIET: 'microkrediet',
    PRODUCTBELEGGEN: 'product-beleggen',
    PRODUCTBETALEN: 'product-betalen',
    PRODUCTHYPOTHEKEN: 'product-hypotheken',
    PRODUCTLENEN: 'product-lenen',
    PRODUCTOVERIG: 'product-overig',
    PRODUCTPENSIOEN: 'product-pensioen',
    PRODUCTSPAREN: 'product-sparen',
    PRODUCTVERZEKEREN: 'product-verzekeren',
    PUSHNOTIFICATIE: 'push-notificatie',
    SALDOGRAFIEK: 'saldografiek',
    SAMEN: 'samen',
    SAMENNOBG: 'samen-nobg',
    THUISGESTUURD: 'thuisgestuurd',
    UZELF: 'uzelf',
    UZELFNOBG: 'uzelf-nobg',
    VERDERINAPP: 'verder-in-app',
    VINGERAFDRUK: 'vingerafdruk',
    VIRTUELEPAS: 'virtuele-pas',
    VOLKSBANK: 'volksbank',
    VOLKSBANKDARK: 'volksbank-dark',
    WEEGSCHAAL: 'weegschaal',
    WELKOM: 'welkom',
    WELKOMTERUG: 'welkom-terug'
};
